import { UserApi } from '../../../common/constants/user-api';
import { getResponseData } from '../../../common/utils/api-utils';
import { getAppFlow } from '../utils/user-profile.util';

export const getSchoolByXid = async (xid) => {
  const url = new URL(UserApi.getSchoolByXid(xid));
  return await getResponseData(
    new Request(url.toString(), {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'Flow': getAppFlow()
      }
    })
  );
};
